/* eslint-disable react/prop-types */
import React from 'react';
import { H4, Subtext, BlankLink, FlexRow, BaseCol } from '@contently/toolkit';

const TitleCell = ({ cell }) => {
  const { published_to_url: publishedToUrl, creator, title, id } = cell.row.original;

  return (
    <div>
      <FlexRow align="left">
        <BaseCol default={10}>
          <a className="roi-link" href={`${window.origin}/stories/${id}`}>
            <H4>{title}</H4>
          </a>
        </BaseCol>
        <BaseCol default={1}>{publishedToUrl && <BlankLink href={publishedToUrl} />}</BaseCol>
      </FlexRow>
      <Subtext>By {creator}</Subtext>
    </div>
  );
};

export default TitleCell;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/TitleCell.jsx